module.exports = __webpack_public_path__ + "static/media/СЗФО_97.9ff3495a.png";